// Chakra imports
import {Box, Flex, Grid, Image, SimpleGrid, useColorModeValue,} from "@chakra-ui/react";
// assets
// Custom icons
import React, {useEffect, useState} from "react";
import MiniStatistics from "./components/MiniStatistics";
import logoChakra from "../../../assets/logo/logo.png";
import BuiltByDevelopers from "./components/BuiltByDevelopers";
import {BellIcon, RepeatIcon} from "@chakra-ui/icons";
import {fetchDashboardDonutChart, fetchDashboardTiles} from "../services";
import {CartIcon} from "../../../components/Icons/Icons";
import SalesOverview from "./components/SalesOverview";
import DonutChart from "./components/charts/DonutChart";
import TopSchools from "./components/TopSchools";

export default function Dashboard() {

    const iconBoxInside = useColorModeValue("white", "white");
    const [tiles, setTiles] = useState([]);
    const [piechartData, setPieChartData] = useState({});
    const [tilesLoading, setTilesLoading] = useState(true);
    const [piechartLoading, setPiechartLoading] = useState(true);

    useEffect(() => {
        fetchDashboardTileData();
        fetchDashboardDonutChartData();
    }, []);

    const fetchDashboardTileData = async () => {

        setTilesLoading(true);
        try {
            const response = await fetchDashboardTiles();
            if (response.status === 200) {
                setTiles(response.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setTilesLoading(false);
        }

    }

    const fetchDashboardDonutChartData = async () => {

        setPiechartLoading(true);
        try {
            const response = await fetchDashboardDonutChart();
            if (response.status === 200) {
                setPieChartData(response.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setPiechartLoading(false);
        }

    }

    return (
        <Flex flexDirection='column' pt={{base: "82px", md: "88px", xl: "75px"}} minW="0">

            <SimpleGrid columns={{sm: 1, md: 2, xl: 4}} spacing='24px'>
                <MiniStatistics
                    title={"School"}
                    amount={tiles?.totalSchool}
                    // percentage={55}
                    isLoading={tilesLoading}
                    icon={<BellIcon h={"24px"} w={"24px"} color={iconBoxInside}/>}
                />
                <MiniStatistics
                    title={"Users"}
                    amount={tiles?.totalUser}
                    // percentage={5}
                    isLoading={tilesLoading}
                    icon={<RepeatIcon h={"24px"} w={"24px"} color={iconBoxInside}/>}
                />
                <MiniStatistics
                    title={"Bell"}
                    amount={tiles?.totalBellMusic || 0}
                    // percentage={5}
                    isLoading={tilesLoading}
                    icon={<BellIcon h={"24px"} w={"24px"} color={iconBoxInside}/>}
                />
                <MiniStatistics
                    title={"App Download"}
                    amount={0}
                    percentage={8}
                    isLoading={tilesLoading}
                    icon={<CartIcon h={"24px"} w={"24px"} color={iconBoxInside}/>}
                />
            </SimpleGrid>

            <Grid
                templateColumns={{sm: "1fr", lg: "1.3fr 1.7fr"}}
                templateRows={{sm: "repeat(2, 1fr)", lg: "1fr"}}
                gap='24px'
                mb={{lg: "26px"}}>
                <DonutChart piechartData={piechartData} isLoading={piechartLoading}/>
                {/*<ActiveUsers*/}
                {/*    title={"Active Users"}*/}
                {/*    percentage={23}*/}
                {/*    chart={<BarChart/>}*/}

                {/*/>*/}
                <SalesOverview
                    title={"Sales Overview"}
                    percentage={5}
                />
            </Grid>

            {/*<Grid w={{base: "100%", lg: "50%"}} mb="26px">*/}
            <Grid>
                <TopSchools/>
            </Grid>

            <Grid
                templateColumns={{md: "1fr", lg: "1.8fr 1.2fr"}}
                templateRows={{md: "1fr auto", lg: "1fr"}}
                my='26px'
                gap='24px'>
                <BuiltByDevelopers
                    title={"शिक्षक र विद्यार्थीहरूका लागि\n" +
                        "डिजिटल घण्टी प्रणाली"}
                    name={"तपाईंलाई स्वागत छ!"}
                    description={
                        "शिक्षक र विद्यार्थीहरूका लागि\n" +
                        "डिजिटल घण्टी प्रणाली\n" +
                        "तपाईंलाई स्वागत छ!\n" +
                        "\n" +
                        "रंगहरू, कार्डहरू, समय तालिका, र जटिल सुविधाहरूको पूर्ण विवरण यहाँ उपलब्ध छ।\n" +
                        "प्रयोग गर्न सजिलो, स्मार्ट व्यवस्थापन, र समयमै सूचना।\n" +
                        "\n" +
                        "\"विद्यालयलाई समयमा चलाउने हाम्रो जिम्मेवारी, डिजिटल घण्टी हाम्रो सहायक।\"\n" +
                        "\n" +
                        "शुभ यात्रा!\n" +
                        "डिजिटल घण्टी प्रबंधन प्रणाली"
                    }
                    image={
                        <Image
                            src={logoChakra}
                            alt='chakra image'
                            minWidth={{md: "100px", lg: "auto"}}
                        />
                    }
                />

                {/*<WorkWithTheRockets*/}
                {/*    backgroundImage={peopleImage}*/}
                {/*    title={"Work with the rockets"}*/}
                {/*    description={*/}
                {/*        "Wealth creation is a revolutionary recent positive-sum game. It is all about who takes the opportunity first."*/}
                {/*    }*/}
                {/*/>*/}
            </Grid>

        </Flex>
    );
}
